const nodes = []
export default {
  nodes
}




// WEBPACK FOOTER //
// ./src/assets/js/global.js